import { Target, TrendingUp } from "lucide-react";
import Chart from "react-apexcharts";
import MyTooltip from "./MyTooltip";

export default function StatCard({
  color = "#2563eb",
  lable = "",
  icon,
  value,
  info = [],
  graphData = [],
}) {
  const Icon = icon ?? Target;
  const chartOptions = {
    colors: [color],
    chart: {
      toolbar: { show: false },
      sparkline: { enabled: true },
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    fill: {
      opacity: 0.15,
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.15,
        opacityTo: 0,
      },
    },
    tooltip: {
      enabled: false,
    },
    grid: {
      show: false,
    },
    xaxis: {
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      show: false,
    },
  };

  const chartSeries = [
    {
      name: "CTR",
      data: graphData,
    },
  ];

  return (
    <div className="min-w-40 rounded-[20px] bg-slate-200/40 dark:bg-slate-900 border border-slate-600 shadow-[0_10px_30px_rgba(0,0,0,0.06)] p-4">
      {/* Top Section */}
      <div className="flex items-start justify-between">
        {/* Icon */}

        <Icon
          className={`w-10 h-10  p-2 rounded-xl font-bold`}
          strokeWidth={2.2}
          
          fontSize={"large"}
          sx={{ fontSize: 39 }}
          style={{
            color: color,
            backgroundColor: `${color}40`,
          }}
        />

        {/* Growth Badge */}
        <div className="px-2 py-1 rounded-full bg-[#e8f7ea] flex items-center gap-2">
          <TrendingUp className="w-4 h-4 text-[#16a34a]" />

          <span className="text-[#16a34a] text-[14px] font-semibold">
            +0.12%
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="mt-4">
        <div className="flex items-center justify-start space-x-1">
          <p className="text-[16px] font-semibold text-slate-600 dark:text-slate-400">
            {lable}
          </p>
          <MyTooltip msg={info} tpId={`${lable}`} />
        </div>

        <h1 className="mt-1 text-[24px] leading-none font-bold text-slate-600 dark:text-slate-300">
          {value}
        </h1>
      </div>
      {/* Graph */}
      <div className="mt-auto w-full  overflow-hidden">
        <Chart
          options={chartOptions}
          series={chartSeries}
          type="area"
          height={80}
          width="100%"
        />
      </div>
    </div>
  );
}
